import { render, staticRenderFns } from "./DialogCreateCandidatoComponent.vue?vue&type=template&id=3b607f28&"
import script from "./DialogCreateCandidatoComponent.vue?vue&type=script&lang=js&"
export * from "./DialogCreateCandidatoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports